/**
 * permissions-check に投げる API ターゲット。
 *
 * 情報源は SpiffArena 標準フロントの
 * infra/frontend-source/spiff-arena/spiffworkflow-frontend/src/hooks/UriListForPermissions.tsx。
 * 自社フロントで使う分だけを写している。
 *
 * ロール名（admin / approver 等）は SPA に持ち込まず、ここへの可否＝能力で分岐する。
 * IdP や permissions YAML の語彙が変わっても UI の条件式は変わらない。
 */
export const PERMISSION_TARGETS = {
  /** 自分の案件一覧（マイ案件） */
  processInstanceListForMe: "/v1.0/process-instances/for-me",
  /** 全案件一覧。閲覧できる＝管理者相当 */
  processInstanceList: "/v1.0/process-instances",
  /**
   * 個別案件の閲覧（関与していない案件も開けるか）。
   *
   * SpiffArena は一覧（レポート照会）と個別案件の閲覧を別の権限にしており、
   * 承認者は一覧だけ通る。一覧に出すなら開けなければならないので、横断の画面は
   * こちらで判定する。URI はモデル・案件に依らない代表値
   * （管理者は `/*` を持つので true、それ以外は false になる）。
   */
  processInstanceDetail: "/v1.0/process-instances/*/*",
  /** 保存ビュー（process instance report） */
  processInstanceReportList: "/v1.0/process-instances/reports",
  processGroupList: "/v1.0/process-groups",
  /** 案件種別カタログ／プロセス設計 */
  processModelList: "/v1.0/process-models",
  taskList: "/v1.0/tasks",
  messageList: "/v1.0/messages",
  secretList: "/v1.0/secrets",
  userSearch: "/v1.0/users/search",
  status: "/v1.0/status",
} as const;

export type PermissionTarget =
  (typeof PERMISSION_TARGETS)[keyof typeof PERMISSION_TARGETS];

export type HttpMethod = "GET" | "POST" | "PUT" | "DELETE";
